import { Toast } from "@newsela/angelou";
import { isEmpty, every, pickBy, some, isNil, keys } from "@s-libs/micro-dash";

import isValidEmailPattern from "@/utils/isValidEmailPattern";

const isNotEmpty = (item) => !isEmpty(item);
const isNotNil = (item) => !isNil(item);

export const FORM_VALIDATION = {
  user: {
    first_name: isNotEmpty,
    last_name: isNotEmpty,
    username: isNotEmpty,
    email: (item) => isEmpty(item) || isValidEmailPattern(item),
    is_active: isNotNil,
  },
};

export const INVALID_FIELD_MESSAGE = "Invalid field";

export const EVENT_TOAST_SUCCESS_UPDATED = {
  showIcon: true,
  statusColor: Toast.statusColor.success,
  children: "Profile updated",
};

export const EVENT_TOAST_FAILED_UPDATED = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Update failed",
};

export const getUpdatedFields = (initialForm, form) => {
  return pickBy(form, (item, key) => item !== initialForm[key]);
};

export const getInvalidFields = (updatedFields, validations = {}) => {
  return keys(
    pickBy(
      updatedFields,
      (item, key) => validations[key] && !validations[key](item),
    ),
  );
};

export const canSubmitForm = (invalidFields, updatedFields) => {
  const isFormValid = every(invalidFields, isEmpty);
  const isFormUpdated = some(updatedFields, isNotEmpty);
  return isFormValid && isFormUpdated;
};
